<template>
    <div class="page-bg" style="display: flex; padding: 0;">
      <!-- <el-col :span="3"> -->
        <div class="side-box">
          <div class="project-side">{{ Lang.btn.gatewayDevice }}</div>
          <el-scrollbar height="790px">
            <div class="tree-box">
              <avue-tree
                ref="treeRef"
                :option="treeOption"
                :data="treeData"
                @node-click="nodeClick"
              >
                <template #="{ node, data }">
                  <span class="el-tree-node__label">
                    <template v-if="node.data.rank!==2">
                      <comp-icon v-if="node.data.commStatus === 1" name="signal-ok" size="12px" style="margin: 2px 4px 0 0" ></comp-icon>
                      <comp-icon v-else name="signal-err" size="12px" style="margin: 2px 4px 0 0" ></comp-icon>
                      <!-- <comp-icon v-if="node.data.commStatus === 1" name="online"></comp-icon>
                      <comp-icon v-else name="offline"></comp-icon> -->
                    </template>
                    {{ (node || {}).data.name }}
                  </span>
                </template>
              </avue-tree>
            </div>
          </el-scrollbar>
        </div>
      <!-- </el-col> -->
      <div class="flex-col" style="width: 50vw;">
        <basic-card hideHeader :style="{ overflowY: 'hidden' }">
          <avue-crud
            :option="option"
            v-model:search="search"
            :table-loading="loading"
            :data="data"
            ref="crud"
            v-model="form"
            :permission="permissionObj"
            @row-del="rowDel"
            @row-update="rowUpdate"
            @row-save="rowSave"
            :before-open="beforeOpen"
            v-model:page="page"
            @search-change="searchChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="refreshChange"
            @on-load="onLoad"
          >
            <template #menu-left>
              <compTabs @change="handleTabChange" />
            </template>
          </avue-crud>
          <div class="submit-row">
            <el-button type="primary" @click="confirmSelect">{{ Lang.btn.confirm }}</el-button>
          </div>
        </basic-card>
      </div>
    </div>
  </template>
  
  <script>
  import {
    add,
  } from '@/api/system/user';
  import { 
    getTreeList,
    getPage,
    remove,
    update,
    getDetail,
    alarmSetting,
    getAlramList,
  } from '@/api/gateway/data';
  import { mapGetters } from 'vuex';
  import website from '@/config/website';
  import 'nprogress/nprogress.css';
  import func from '@/utils/func';
  import compTabs from '@/components/comp-tab/index.vue';
  import { deepClone } from '@/utils/util';
  
  export default {
    components: {
      compTabs,
    },
    data() {
      return {
        form: {},
        search: {},
        roleBox: false,
        configBox: false,
        itemId: '',
        excelBox: false,
        platformBox: false,
        initFlag: true,
        auditMode: false,
        selectionList: [],
        query: {},
        loading: true,
        addBtn: false,
        editBtn: false,
        platformLoading: false,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        platformPage: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        init: {
          roleTree: [],
          deptTree: [],
        },
        props: {
          label: 'title',
          value: 'key',
        },
        roleGrantList: [],
        roleTreeObj: [],
        treeDeptId: '',
        treeData: [],
        treeOption: {
          nodeKey: 'id',
          lazy: false,
          addBtn: false,
          menu: false,
          size: 'small',
          filterText: this.Lang.tips.plzInputFilterText,
          props: {
            labelText: this.Lang.tips.title,
            label: 'name',
            value: 'code',
            children: 'childTreeList',
          },
          treeLoad: function (node, resolve) {
            const parentId = node.rank === 1 ? '00' : node.data.parentId;
            const params = {
              parentId,
            }
            getTreeList(params).then(res => {
              resolve(
                res.data.data.map(item => {
                  return {
                    ...item,
                    leaf: !item.childTreeList.length,
                  };
                })
              );
            });
          },
        },
        option: {
          height: '650px',
          calcHeight: '50px', // 表格的高度增加量，默认为自动高度。如果设置为auto，会自适应窗口高度。
          tip: false,
          searchShow: true, // 搜索栏
          searchMenuSpan: 6,
          gutter: 12,
          border: false, // 每行的竖线
          index: true,
          indexLabel: this.Lang.table.serialNumber,
          indexWidth: 50,
          selection: true, // 选择
          menu: false, // 操作列是否展示
          addBtn: false, // 添加
          viewBtn: false, // 查看
          editBtn: false, // 编辑
          delBtn: false, // 删除
          menuType: 'button',
          menuTitle: this.Lang.label.operation,
          menuHeaderAlign: 'right', // 操作按钮样式
          menuLabelClassName: '',
          dialogType: 'drawer', // dialog drawer
          dialogClickModal: false,
          dialogMenuPosition: 'center', // 弹窗按钮位置
          emptyBtnText: this.Lang.btn.empty,
          column: [ // 表格列
            {
              label: this.$t('theader.measuringPoint'),
              prop: 'id',
              search: false,
              display: false,
            },
            {
              label: this.$t('theader.name'),
              prop: 'name',
              slot: false, // 自定义内容格式化
              display: false,
            },
            {
              label: this.Lang.label.fourRemoteType,
              prop: 'stype',
              slot: false, // 自定义内容格式化
              display: false,
              dicUrl: '/blade-system/dict/dictionary?code=typesOfTelemetering',
              dataType: 'string',
              props: {
                label: 'i18nValue',
                value: 'dictKey',
              },
              reonly: true,
              type: 'select',
            },
            {
              label: this.$t('theader.realTimeValue'),
              prop: 'val',
              search: false,
              display: false,
            },
            {
              label: this.$t('theader.unit'),
              prop: 'unit',
              search: false,
              display: false,
            },
            {
              label: this.$t('theader.updateTime'),
              prop: 'updateTime',
              slot: false,
              display: false,
            },
            {
              label: this.Lang.table.ifSave,
              prop: 'store',
              slot: false,
              display: false,
            },
            {
              label: this.Lang.table.factor,
              prop: 'factor',
              slot: false,
              display: false,
            },
          ],
        },
        data: [],
      };
    },
    watch: {
      'form.tenantId'() {
        if (this.form.tenantId !== '' && this.initFlag) {
          this.initData(this.form.tenantId);
        }
      },
    },
    computed: {
      ...mapGetters(['menuItem', 'permission']),
      permissionObj() {
        const keys = Object.keys(this.permission)
        const obj = {}
        const menuId = this.menuItem.id;
        keys.forEach((key => {
          if (key.indexOf(menuId) > -1) {
            const btnType = key.substr(menuId.length);
            obj[btnType] = true;
            obj[btnType+'Btn'] = true; // 兼容
            if (btnType === 'delete') {
              obj.delBtn = true;
            }
          }
        }))
        return obj
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    mounted() {
      this.initData(website.tenantId);
    },
    created() {
    },
    methods: {
      handleClickFirstNode() {
        const tree = this.$refs.treeRef;
        if (tree) {
          const firstNode = this.getFirstNode(this.treeData);
          if (firstNode) {
            // 触发点击事件或展开节点
            tree.setCurrentKey(firstNode.id); // 设置当前选中的节点
            tree.nodeClick(firstNode); // 模拟点击事件
          }
        }
      },
      getFirstNode(data) {
        for (const node of data) {
          if (node.children && node.children.length > 0) {
            return this.getFirstNode(node.children); // 递归查找子节点
          }
          return node; // 返回第一个找到的节点
        }
        return null;
      },
      // 把选中的数据带到上一级
      confirmSelect() {
        const list = deepClone(this.selectionList)
        this.$emit('selectChange', list);
      },
      formAddRow(row) {
        // 添加一个新的行
        this.settingForm.dynamicFields.push({ key: '', value: '' });
      },
      formRemoveRow(index) {
        // 删除指定的行
        this.settingForm.dynamicFields.splice(index, 1);
      },
      handleSetting(row) {
        this.itemId = row.id;
        getAlramList(row.id).then(res => {
          let alarmList = [];
          if (res.status === 200) {
            alarmList = res.data.data;
          } else {
            alarmList = [{}]
          }
          this.configBox = true;
          this.$nextTick(() => {
            this.$refs.AlarmConfigModel.updateAlarmList(alarmList);
          })
        });
      },
      handleCancel() {
        this.configBox = false;
      },
      // 报警配置提交
      handleSubmit(form, done, loading) {
        const list = form.dynamic;
        const params = []
        const itemId = this.itemId;
        list.map(item => {
          params.push(
            {
              id: item.id,
              tenantId: item.tenantId,
              itemId: itemId,
              alarmType: item.alarmType,
              alarmLevel: item.alarmLevel,
              alarmVal: item.alarmVal,
            }
          )
        })
        alarmSetting(itemId, params).then(
          () => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: this.Lang.tips.configSucceed,
            });
            done();
            this.configBox = false;
          },
          error => {
            window.console.log(error);
            loading();
          }
        );
      },
      handleAdd(row) {
        this.parentId = row.id;
        const column = this.findObject(this.option.column, 'parentId');
        column.value = row.id;
        column.addDisabled = true;
        this.$refs.crud.rowAdd();
      },
      handleTabChange(i, item) {
        const params = {
          stype: item.value
        }
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
      },
      getNodeData(node) {
        console.log(node)
      },
      nodeClick(data) {
        this.rtuId = data.id;
        this.page.currentPage = 1;
        this.onLoad(this.page);
      },
      initData(tenantId) {
        getTreeList().then(res => {
          const data = res.data.data;
          data.map(item => {
            return {
              ...item,
              leaf: !item.childTreeList.length,
            };
          })
          this.treeData = data;
          this.$nextTick(() => {
            this.handleClickFirstNode()
          })
        });
      },
      rowSave(row, done, loading) {
        row.deptId = func.join(row.deptId);
        row.roleId = func.join(row.roleId);
        row.postId = func.join(row.postId);
        add(row).then(
          () => {
            this.initFlag = false;
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
            done();
          },
          error => {
            window.console.log(error);
            loading();
          }
        );
      },
      rowUpdate(row, index, done, loading) {
        row.deptId = func.join(row.deptId);
        row.roleId = func.join(row.roleId);
        row.postId = func.join(row.postId);
        update(row).then(
          () => {
            this.initFlag = false;
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
            done();
          },
          error => {
            window.console.log(error);
            loading();
          }
        );
      },
      rowDel(row) {
        this.$confirm(this.Lang.tips.ifConfirmDelete, {
          confirmButtonText: this.Lang.btn.confirm,
          cancelButtonText: this.Lang.btn.cancel,
          type: 'warning',
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
          });
      },
      searchReset() {
        this.query = {};
        this.treeDeptId = '';
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        // this.$refs.crud.toggleSelection();
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail(this.form.id).then(res => {
            this.form = res.data.data;
            if (this.form.hasOwnProperty('deptId')) {
              this.form.deptId = func.split(this.form.deptId);
            }
            if (this.form.hasOwnProperty('roleId')) {
              this.form.roleId = func.split(this.form.roleId);
            }
            if (this.form.hasOwnProperty('postId')) {
              this.form.postId = func.split(this.form.postId);
            }
          });
        }
        this.initFlag = true;
        done();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        this.loading = true;
        params.rtuId = this.rtuId;
        getPage(
          page.currentPage,
          page.pageSize,
          Object.assign(params, this.query, { status: this.auditMode ? 0 : 1 }),
        ).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .el-scrollbar {
    height: 100%;
  }
  .el-scrollbar__wrap {
    overflow: scroll;
  }
.submit-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-top: 20px;
}
</style>
  